import { render } from "./CalendarButton.vue?vue&type=template&id=25ced2b5"
import script from "./CalendarButton.vue?vue&type=script&lang=js"
export * from "./CalendarButton.vue?vue&type=script&lang=js"

import "./CalendarButton.vue?vue&type=style&index=0&id=25ced2b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__